module.exports = __webpack_public_path__ + "static/media/udit.106cbb53.jpg";